import React, { Component } from "react"
import Svg from "../_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import Slider from "react-slick"
import { handleClickTracking } from "../../helpers/tracking"

export default class ImageListGridCarousel extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  componentDidMount() {
    window.addEventListener("resize", (event) => {
      this.setState({ screenWidth: event.target.screen.width })
    })
  }

  render() {
    if (!(this.props.contentArea && this.props.contentArea.length > 0)) return ""

    var settings = {
      dots: true,
      arrows: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      swipe: true,
      variableWidth: true,
    }

    if (this.props.contentArea.length > 3) {
      settings.arrows = true
    }

    const innerWidth = window.innerWidth

    if (innerWidth >= 768 && innerWidth < 920) {
      settings.slidesToShow = 2
    }

    // let typeClass = "mobile-list"
    // if (this.props.contentArea.length % 2=== 0)
    //     typeClass = "mobile-gallery"

    const topPadding = SelectionFactoryHelper.getFromSelectionFactory(this.props.topPadding)
    const underThree = this.props.contentArea.length < 3
    const backgroundColor = this.props.backgroundColor ? this.props.backgroundColor[0]?.value : ""

    return (
      <div
        className={`image-list-grid-carousel mobile-list ${topPadding ? topPadding : ""} ${underThree ? "under-three" : ""} ${backgroundColor || ""}`}
      >
        <div className="w--normal">
          <div className="image-list-grid-carousel-content">
            <h2>{this.props.heading}</h2>
            {innerWidth < 768 ? (
              this.props.contentArea.map((item, index) => {
                return <ImageLinkItem key={index} {...item} index={index} />
              })
            ) : (
              <Slider {...settings}>
                {this.props.contentArea.map((item, index) => {
                  return <ImageLinkItem key={index} {...item} index={index} />
                })}
              </Slider>
            )}
          </div>
        </div>
      </div>
    )
  }
}

class ImageLinkItem extends Component {
  render() {
    const { linkTarget, linkText, linkTracking, linkUrl } = this.props.link
    const target = SelectionFactoryHelper.getFromSelectionFactory(linkTarget)
    return (
      <a className="image-item" href={linkUrl} onClick={() => handleClickTracking(linkTracking)} target={target}>
        {this.props.image && window.innerWidth < 768 ? (
          <img src={this.props.image} />
        ) : this.props.image ? (
          <div className="image-wrapper">
            <img src={this.props.image} />
          </div>
        ) : (
          ""
        )}
        <div className="textarea">
          <div className="flex-container">
            {linkText}
            <Svg iconName="arrowright-slim" fillColor={"transparent"} stroke={"#071143"} />
          </div>
        </div>
      </a>
    )
  }
}
